import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LogService } from "src/app/services/log.service";
import { CORES_STATUS_OS, STATUS_OS } from "src/app/shareds/constantes";
import { SimpleChanges } from "@angular/core";

@Component({
  selector: "app-log-avaliacao",
  templateUrl: "./log-avaliacao.component.html",
  styleUrls: ["./log-avaliacao.component.scss"],
})
export class LogAvaliacaoComponent implements OnInit {
  constructor(
    private logService: LogService,
    private modalService: NgbModal,
  ) {}

  @Input() public inputOSId: number = 0;
  @Input() public shouldOpenModal: boolean;
  @ViewChild("modal") modal: ElementRef;
  @Output() public changeShowModal = new EventEmitter();

  bgCoresStatus: string[] = CORES_STATUS_OS;
  statusOS: string[] = STATUS_OS;

  logsAvaliacao: any[] = [];

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    setTimeout(() => {
      this.getLogAvaliacoes();
    });
  }

  openModal() {
    this.modalService.open(this.modal, { windowClass: "xlModal" });
  }

  getLogAvaliacoes() {
    this.logService
      .getLogAvaliacoesPelaOSId(this.inputOSId)
      .subscribe((response: any[]) => {
        this.logsAvaliacao = response;
        this.openModal();
      });
  }

  fecharModal(c: any) {
    this.changeShowModal.emit();
    c("Close click");
  }
}
